<script lang="ts">
  import { onMount } from 'svelte';
  import type { Capabilities, Conversation } from '../shared/types';
  import { get } from './api';
  import ChatView from './components/ChatView.svelte';
  import EmptyState from './components/EmptyState.svelte';
  import NamePrompt from './components/NamePrompt.svelte';
  import QuickDialog from './components/QuickDialog.svelte';
  import Settings from './components/Settings.svelte';
  import Sidebar from './components/Sidebar.svelte';
  import { connectSocket } from './socket';
  import { chat } from './store';

  let dialog = $state<'room' | 'join' | null>(null);

  const conversations = $derived($chat.conversations);
  const active = $derived(conversations.find((item) => item.id === $chat.activeId) ?? null);

  onMount(() => {
    const disconnect = connectSocket();
    Promise.all([get<{ conversations: Conversation[] }>('/api/conversations'), get<Capabilities>('/api/capabilities')])
      .then(([list, capabilities]) => {
        chat.setConversations(list.conversations);
        chat.setCapabilities(capabilities);
      })
      .catch((error: Error) => chat.notify(`Cannot reach the server: ${error.message}`, 'error'));
    return disconnect;
  });

  $effect(() => {
    if (!$chat.activeId && conversations.length) chat.setState({ activeId: conversations[0].id });
  });
</script>

<div class={`app ${active ? 'chat-open' : ''} ${$chat.mobileChat ? 'mobile-chat' : ''}`}>
  <Sidebar onNewRoom={() => (dialog = 'room')} onJoin={() => (dialog = 'join')} />
  {#if active}
    {#key active.id}
      <ChatView conversation={active} />
    {/key}
  {:else}
    <EmptyState />
  {/if}
  {#if $chat.settingsOpen}<Settings />{/if}
  {#if dialog}<QuickDialog mode={dialog} onClose={() => (dialog = null)} />{/if}
  <NamePrompt />
  {#if $chat.toast}<div class={`toast ${$chat.toast.kind}`}>{$chat.toast.text}</div>{/if}
</div>
